import { render, staticRenderFns } from "./ProtocolConversations.vue?vue&type=template&id=13ad22c2&scoped=true&"
import script from "./ProtocolConversations.vue?vue&type=script&lang=js&"
export * from "./ProtocolConversations.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolConversations.vue?vue&type=style&index=0&id=13ad22c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ad22c2",
  null
  
)

export default component.exports